import React from "react";

import DeliveryCourierBankPage from "./DeliveryCourierBankPage";

export default function DeliveryWallet() {
  return <DeliveryCourierBankPage />;
}
